/**
 * The panel's hotkeys step focus from row to row. A row's popover opens as a step
 * lands on it, and swaps in without animating when the step leaves another's.
 * Rows hear of a step for the rest of the task that made it: in the focus events,
 * and in the microtask in which a popup closes on losing focus.
 */
let step: { fromPopover: boolean } | null = null
const stepListeners = new Set<() => void>()

export function stepToRow(row: HTMLElement, from: HTMLElement | undefined) {
  step = { fromPopover: !!from?.hasAttribute('data-popup-open') }
  setTimeout(() => {
    step = null
  })
  for (const listener of stepListeners) listener()
  row.focus({ preventScroll: true })
}

/** Calls `listener` as each step starts, before focus moves. */
export function onRowStep(listener: () => void) {
  stepListeners.add(listener)
  return () => {
    stepListeners.delete(listener)
  }
}

/** Whether focus is moving by a step, rather than a click or a closing popup handing it back. */
export function isRowStep() {
  return step !== null
}

/** Whether the step is leaving a row with its popover up, so popovers swap instead of fading. */
export function isPopoverSwap() {
  return !!step?.fromPopover
}
